import Vue from "vue";
import Vuex from "vuex";
//import getters from "./getter.js";
Vue.use(Vuex);

//#region 自动导入vuex modules
const files = require.context("./modules", false, /\.js$/);
const modules = {};

files.keys().forEach(key => {
    modules[key.replace(/(\.\/|\.js)/g, "")] = files(key).default || files(key);
});

// 判断环境 vuex提示生产环境中不使用
import createPersistedState from "vuex-persistedstate";
import createLogger from "vuex/dist/logger";
const debug = process.env.NODE_ENV !== "production";
const createPersisted = createPersistedState({
    storage: window.sessionStorage,
});

const REQUEST_LOADING = "REQUEST_LOADING";

const store = new Vuex.Store({
    state: {
        loading:false
    },
    mutations: {
        [REQUEST_LOADING](state, loading) {
            state.loading = loading;
        },
    },
    actions: {},
    modules,
    plugins: debug ? [createLogger(), createPersisted] : [createPersisted] // vuex持久化
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js